<template>
  <div>
    <div class="title">
      <h1 v-bg-typography="'h1'" :style="{ marginTop: '10px' }">
        Resources
      </h1>
      <bg-button
        v-if="userState.user.company.id === 2"
        text="New article"
        @click="$router.push(`/resources/new`)"
      ></bg-button>
    </div>
    <bg-loader :dark="true" v-if="this.isLoading"></bg-loader>
    <div class="top" v-if="!this.isLoading">
      <bg-field
        class="search-input"
        label="Search"
        v-model="searchString"
        name="search"
        style="max-width: 300px"
      >
        <bg-input
          name="search"
          height="46px"
          placeholder="Search on title or tags"
          v-model="searchString"
        />
      </bg-field>
      <bg-field class="field" label="Type of resource">
        <bg-select
          placeholder="Filter on type"
          style="max-width: 300px"
          @change="selectType"
          :options="typeOptions"
          :value="type"
        ></bg-select>
      </bg-field>
    </div>
    <div class="items" v-show="!this.isLoading">
      <div
        class="item"
        v-for="(item, index) in filtered"
        :key="index"
        @click="$router.push(`/resources/${item.id}`)"
      >
        <ArticleCard :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
import BgTypography from "@/directives/bg-typography";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import ArticleCard from "@/components/article-card";
import BgButton from "@/components/bg-button";
import API from "@/api";
import { mapState } from "vuex";
import BgSelect from "@/components/bg-select";
import BgLoader from "@/components/bg-loader";
export default {
  directives: {
    BgTypography,
  },
  components: {
    BgField,
    BgInput,
    ArticleCard,
    BgButton,
    BgSelect,
    BgLoader,
  },
  data() {
    return {
      items: [],
      isLoading: true,
      searchString: "",
      typeOptions: [
        { label: "All", code: 99 },
        { label: "Help", code: 0 },
        { label: "Blog", code: 1 },
        { label: "Product update", code: 2 },
        { label: "News", code: 3 },
        { label: "Case", code: 4 },
      ],
      type: {
        label: "All",
        code: 99,
      },
    };
  },
  watch: {
    "$route.query.tag": {
      handler: function(newVal, oldVal) {
        if (newVal != oldVal) {
          this.searchString = newVal;
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
    }),
    query: function() {
      return this.$route.query;
    },
    filtered: function() {
      let filtered = this.items.filter(
        (resource) =>
          resource.title
            .toLowerCase()
            .includes(this.searchString.toLowerCase()) ||
          resource.tags.some((tag) =>
            tag.toLowerCase().includes(this.searchString.toLowerCase())
          )
      );

      if (this.userState.user.company.id != 2) {
        filtered = filtered.filter((r) => r.published);
      }

      if (this.type.code != 99) {
        filtered = filtered.filter((r) => r.type === this.type.code);
      }

      return filtered;
    },
  },
  async mounted() {
    const result = await API.resource.getResources();
    result.resources.forEach((resource) => {
      this.items.push({
        title: resource.title,
        tags: resource.tags,
        date: resource.date,
        author: resource.author,
        favorited: false,
        image: resource.image,
        id: resource.id,
        published: resource.published,
        type: resource.resource_type,
      });
    });
    this.isLoading = false;
  },
  methods: {
    selectType(val) {
      this.type = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  display: flex;
  gap: 25px;
}
.items {
  display: flex;
  gap: 25px;
  flex-wrap: wrap;
  margin-bottom: 100px;
}

.title {
  max-width: 950px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
